<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2vTI9O/tc-custom/9781452137001.jpg?1709182264816" alt="This image is the cover for the book Southern Appetizers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Southern Appetizers
      </h1>
      <p class="bookDescription body article font2">
        <b>“Meat pies, po’babies and other Southern nibbles will ‘delightfully extend’ cocktail hour . . . You could party all year with this little book.” —<i>The Dallas Morning News</i></b><br/><br/>Southerners adore their appetizers, and this collection of sixty recipes—served up with a healthy dose of Southern hospitality—shows why. Smoked pecans on the sideboard, cheese straws on the coffee table, an array of hot dips on the dining table, and pickled shrimp on the porch are just some of the myriad dishes found in this volume that prove food is the life of the party. Tips on creating the ideal party flow, being a gracious host, arranging flowers, sending out invitations, and planning the perfect menu ensure any event will go off without a hitch. Both a lovely hostess gift and a party-planning idea book, <i>Southern Appetizers</i> is all anyone needs for a successful gathering with Southern style.<br/><br/><b>“A collection of 60 crowd-pleasing recipes for laidback entertaining, along with seasoned advice for acting as a gracious host and pulling off a party to remember . . . From ‘Pick-Me-Ups’ like handheld snacks, dips, and spreads to heartier starters for sit-down dinners, Denise presents an assemblage of fine-tuned recipes that spans traditional favorites and innovative combinations of familiar flavors . . . [a] scrumptious compilation.” —<i>Southern Lady</i></b><br/><br/><b></b><br/><br/><b>“I found it easy to follow, with accessible recipes and with great photos. Many of the dishes make me think of great Sunday brunches or get-togethers in the South.” —<i>Life’s a Tomato</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Denise Gee, Robert M. Peacock
      </h2>
      
      <p class="authorDescription body article">Denise Gee and Robert M. Peacock are a wife-and-husband team (she writes, he photographs) behind four successful titles with Chronicle Books. They live in Dallas, Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62b62df0